import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Contract } from '../../contracte-programari.interface';
import { SubcontractLocal, SubcontractLocalSlot } from '../../../inregistrare-programare/disponibilitate-programare/disponibilitate.interface';
import { DetaliiProgramareState } from '../../../inregistrare-programare/inregistrare-programare.service';
import { ContracteProgramariService } from '../../contracte-programari.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-subsemnat',
    templateUrl: './subsemnat.component.html',
    styleUrls: ['./subsemnat.component.scss']
})
export class SubsemnatComponent implements OnChanges {
    @Input() contract!: Contract | null;

    expandedSubcontracts: boolean[] = [];
    allExpanded = false;
    isUpdatingPrezenta = false;

    constructor(
        private contracteProgramariService: ContracteProgramariService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['contract'] && this.contract?.subcontracts) {
            this.expandedSubcontracts = this.contract.subcontracts.map(() => false);
            this.allExpanded = false;
        }
    }

    toggleSubcontract(index: number): void {
        this.expandedSubcontracts[index] = !this.expandedSubcontracts[index];
        this.allExpanded = this.expandedSubcontracts.every(v => v);
    }

    toggleAll(): void {
        this.allExpanded = !this.allExpanded;
        this.expandedSubcontracts = this.expandedSubcontracts.map(() => this.allExpanded);
    }

    formatDate(dateStr: string | null | undefined): string {
        if (!dateStr) return 'N/A';
        const [year, month, day] = dateStr.split('-');
        return `${day}.${month}.${year}`;
    }

    // ── Edit subcontract ──────────────────────────────────────────────────────

    editSubcontract(subIndex: number): void {
        if (!this.contract) return;

        const sub = this.contract.subcontracts[subIndex];
        if (!sub) return;

        const allSubcontracteLocale: SubcontractLocal[] = this.contract.subcontracts.map((s: any) => {
            const slots: SubcontractLocalSlot[] = (s.programari ?? []).map((p: any) => ({
                slot_id: p.slot_id,
                date: p.date,
                time_from: p.time_from,
                nume_specialist: p.program_disponibil?.nume_specialist ?? '',
                specialist_id: p.program_disponibil?.specialist_id ?? 0,
            }));
            return {
                subcontract_id: s.id,
                specializare_id: s.specializare_id,
                specializare_name: s.programari?.[0]?.program_disponibil?.denumire_specializare ?? '',
                nr_sedinte: s.nr_sedinte,
                frecventa_sedinte: s.frecventa_sedinte,
                date_from_sedinte: s.date_from_sedinte,
                date_end_sedinte: s.date_end_sedinte,
                timeSlots: slots,
                nr_contract: this.contract!.nr_contract?.toString() ?? '',
                data_contract: this.contract!.data_contract ?? '',
                date_from_contract: this.contract!.date_from_contract,
                date_end_contract: this.contract!.date_end_contract,
                preferinteOrare: s.preferred_timeslots ?? [],
                preluareContract: false,
                noPreferinta: s.preferred_timeslots === null || s.preferred_timeslots?.length === 0,
            };
        });

        const state: DetaliiProgramareState = {
            contractId: this.contract.id,
            selectedStartDate: new Date(this.contract.date_from_contract),
            selectedEndDate: new Date(this.contract.date_end_contract),
            selectedLuni: null,
            nrContract: this.contract.nr_contract?.toString() ?? '',
            dataContract: this.contract.data_contract ?? '',
            subcontracteLocale: allSubcontracteLocale,
            disponibilitateActiva: false,
            sloturiSelectateIds: [],
            fileGroups: this.contract.file_groups ?? [],
        };

        const entitate = {
            id: this.contract.entity.id,
            first_name: this.contract.entity.first_name,
            last_name: this.contract.entity.last_name,
            cnp: this.contract.entity.cnp,
            full_name: this.contract.entity.full_name,
            current_address: this.contract.entity.current_address,
            tutore_relationships: (this.contract.entity as any).tutore_relationships ?? [],
        };

        // Salvăm în sessionStorage la cheie fixă
        sessionStorage.setItem('ext_edit_payload', JSON.stringify({
            state,
            entitate,
            pendingSubcontractId: sub.id,
        }));

        // ?edit=1 în URL — singurul param, fără date sensibile
        window.open('/#/inregistrare-programare/detalii-programare?edit=1', '_blank');
    }

    getStatusClass(status: string): string {
        const map: Record<string, string> = {
            'in-asteptare': 'status-asteptare',
            'anulata': 'status-anulat',
            'absent': 'status-absent',
            'prezent': 'status-prezent',
        };
        return map[status] ?? 'status-asteptare';
    }

    updatePrezenta(id_programare: number, status: string): void {
        const isPresent = status === 'prezent';

        Swal.fire({
            title: isPresent ? 'Marchează prezent' : 'Marchează absent',
            input: 'textarea',
            inputLabel: 'Observații (opțional)',
            inputPlaceholder: 'Adaugă observații...',
            inputAttributes: { 'aria-label': 'Observații' },
            showCancelButton: true,
            confirmButtonText: 'Confirmă',
            cancelButtonText: 'Anulează',
            confirmButtonColor: isPresent ? '#198754' : '#dc3545',
            icon: isPresent ? 'success' : 'warning',
            reverseButtons: true,
        }).then((result) => {
            if (!result.isConfirmed) return;

            const status_obs = result.value?.trim() || undefined;
            this.isUpdatingPrezenta = true;

            this.contracteProgramariService.updatePrezenta(id_programare, status, status_obs).subscribe({
                next: () => {
                    for (const sub of this.contract?.subcontracts ?? []) {
                        const prog = sub.programari.find((p: any) => p.id === id_programare);
                        if (prog) {
                            prog.status = status;
                            prog.status_label = isPresent ? 'Prezent' : 'Absent';
                            break;
                        }
                    }
                    this.isUpdatingPrezenta = false;
                },
                error: (err) => {
                    console.error('Eroare updatePrezenta:', err);
                    this.isUpdatingPrezenta = false;
                }
            });
        });
    }
}